module.exports = __webpack_public_path__ + "01_veryshort_brown.9515831b.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/male/layer5/01_veryshort_brown.png
// module id = /gRN
// module chunks = 0